<label [for]="id">{{ label }}</label>
<div class="input-group">
    <input type="text" class="form-control it-date-datepicker" autocomplete="off" maxlength="10" placeholder="gg/mm/aaaa"
        [id]="id"
        ngbDatepicker
        #datePicker="ngbDatepicker"
        [(ngModel)]="dataStr"
        [disabled]="disabled"
        (blur)="onBlur()"
        (dateSelect)="onBlur()"
        />
    <button aria-label="Calendario" class="btn open-calendar" (click)="datePicker.toggle()" type="button">
        <app-toolkit-bl-icon icon="calendar" cssClass="icon icon-sm"></app-toolkit-bl-icon>
    </button>
</div>